import { ProductSpec } from "../interface"
import { powerArQ3 } from "./power-arq-3"
import { powerArQPro } from "./power-arq-pro"
import { powerArQ2 } from "./power-arq-2"
import { powerArQMini2 } from "./power-arq-mini-2"
import { powerArQMax } from "./power-arq-max"
import { powerArqS7 } from "./power-arq-s7"

export const productSpecs: ProductSpec[] = [
  powerArQMax,
  powerArQ3,
  powerArQPro,
  powerArqS7,
  powerArQ2,
  powerArQMini2,
]